import {
  PracticeModalProvider,
  type CustomTestSettings,
  type TargetedPracticeSettings,
} from '@widgets/NewPracticeModal';

import { Toaster } from '@shared/ui/sonner';

import { RouterProvider } from './providers';
import './styles/index.css';

export const App = () => {
  const handleStartCustomTest = (settings: CustomTestSettings) => {
    void settings;
  };

  const handleStartTargetedPractice = (settings: TargetedPracticeSettings) => {
    void settings;
  };

  return (
    <PracticeModalProvider
      onStartCustomTest={handleStartCustomTest}
      onStartTargetedPractice={handleStartTargetedPractice}
    >
      <RouterProvider />
      <Toaster position="top-right" />
    </PracticeModalProvider>
  );
};
